import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbProgressbarModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { UiModule } from "../ui.module";
import { ContentPosterComponent } from "./content-poster/content-poster.component";
import { ContentTypeBadgeComponent } from "./content-type-badge/content-type-badge.component";

/**
 * How a video or a live stream looks wherever it is listed — the student's own library and the
 * coach's copy of it. Presentational only: what a click does is the hosting application's business.
 */
@NgModule({
  declarations: [ContentPosterComponent, ContentTypeBadgeComponent],
  imports: [CommonModule, NgbProgressbarModule, TranslateModule, UiModule],
  exports: [ContentPosterComponent, ContentTypeBadgeComponent],
})
export class ContentModule {
}
